

const Beta = (props) => {
    
    return (
        <span style={{
            color: props.disabled ? '#ccc' : '#f0ad4e',
            padding: '0 3px',
            marginTop: "0px",
            borderRadius: '4px',
            fontSize: '7pt',
            fontWeight: 'bold',
        }}>
            Beta
        </span>
    );
}

export default Beta;